var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiving(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 4,
    fill: "none",
    stroke: "#272726",
    strokeLinejoin: "round",
    className: "living_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4h16v16H4zM28 4h16v16H28zM4 28h16v16H4zM28 28h16v16H28z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHdpZHRoPSIyNCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48dGl0bGU+Z3JpZCBpbnRlcmZhY2U8L3RpdGxlPjxnIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMyNzI3MjYiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJuYy1pY29uLXdyYXBwZXIiPjxyZWN0IHg9IjQiIHk9IjQiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PC9yZWN0PjxyZWN0IHg9IjI4IiB5PSI0IiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHN0cm9rZT0iIzI3MjcyNiI+PC9yZWN0PjxyZWN0IHg9IjQiIHk9IjI4IiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHN0cm9rZT0iIzI3MjcyNiI+PC9yZWN0PjxyZWN0IHg9IjI4IiB5PSIyOCIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ij48L3JlY3Q+PC9nPjwvc3ZnPg==";
export { SvgLiving as ReactComponent };